import React, { Component } from 'react'
import SearchBar from '@common/SearchBar'
import { Input, DatePicker } from 'hljd'

const Item = SearchBar.Item
const RangePicker = DatePicker.RangePicker

export default class extends Component {
  render() {
    return (
      <SearchBar
        store={this.props.store}
        searchText="查询"
        noNeed={['_phone', '_name', 'exp_saler']}
      >
        <Item label="客户手机" name="_phone">
          <Input style={{ width: 120 }} />
        </Item>
        <Item label="客户姓名" name="_name">
          <Input style={{ width: 120 }} />
        </Item>
        <Item label="销售" name="exp_saler">
          <Input style={{ width: 120 }} />
        </Item>
        <Item label="推荐时间" name="date">
          <RangePicker />
        </Item>
      </SearchBar>
    )
  }
}
